// How the TV host drives a game session.
// - "simulation": the original offline mockup (local timers, fake players).
//   This is what the App.test.tsx suite runs against.
// - "live": the host is a thin client over the real Bun backend (HostClient +
//   hostReducer). Phones join via /join/:code and the server is the controller.
//
// The flag is read from a global injected by src/index.html (the page the real
// backend serves to the TV). Tests render <App /> directly without that page,
// so the global is absent and they always run in simulation — independent of
// any process.env / .env leakage.

export type HostMode = "simulation" | "live";

declare global {
  interface Window {
    __PARTYCAST_MODE__?: "live";
  }
}

export const HOST_MODE: HostMode =
  typeof window !== "undefined" && window.__PARTYCAST_MODE__ === "live"
    ? "live"
    : "simulation";